abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.items = abcsetup.promos.items || {};
abcsetup.promos.items.edit = abcsetup.promos.items.edit || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.items.edit = {
    promo_id: null,
    item_id: null,
    attachment_delete_id: null,

    init: function() {
        abcsetup.setTitle('Update Promotion Item');

        const url = window.location.pathname; // Get the current URL path
        const matches = url.match(/\d+/g); // Match all sequences of digits

        if (matches && matches.length >= 2) {
            abcsetup.promos.items.edit.promo_id = matches[0];
            abcsetup.promos.items.edit.item_id = matches[1];
        }

        // Set the global item var
        abcsetup.item = JSON.parse($('form.promo-item #item_object').val());
        abcsetup.promos.form_manager.form = $('form.promo-item');
        var editable_status = [
            'cm_rejected',
            'vendor_in_process'
        ];

        if (
            abcsetup.userRole.class === 'fs_cm' ||
            abcsetup.userRole.class === 'promo_team'
        )
            abcsetup.promos.form_manager.setFormItems();
        else
            abcsetup.promos.form_manager.setFormItems(!editable_status.includes(abcsetup.item.item_status));

        $(document).on("click","a.update_next_item", function() {
            var item = $(this).data("item");
            $("form.data_input").append('<input type="hidden" name="form_action" value="update"/>');
            $("form.data_input").append('<input type="hidden" name="update_next_item" value="'+item+'"/>');
            if (abcsetup.promos.items.form._validateForm()){
                $("form.data_input").submit();
            }
        });

        $(document).on('change','#billback_perc',function(){
            var  promo_billback_warning = ['rr','rr2','eb','ecomm_sol'];
            if(promo_billback_warning.indexOf(abcsetup.item.promo.type ) !=  -1) {
               $(this).parent().find("div.alert-warning").remove();
               if($(this).val() < 25) {
                  $(this).parent().append("<div class='alert alert-warning mt-1'>Our customers are less likely to order your product because of the Billback %  you provided.<br>In 2019, items promoted at 25% Off or more saw an average increase of 31% <br> in sales units compared to the previous year.<br>We recommend increasing your Billback %. </div>");
               }
            }
         });

        $(document).on('change','#discount_dollar', function(){
            if(abcsetup.item.promo.type == 'hp') {
                $(this).parent().find("div.alert-warning").remove();

                // We need to validate whether the $ off value is less than 10% of the Zone 3 Retail Price. (ABCS-566).
                var zone_price_3 = ( abcsetup.item.a_b_c_item.pricing ? abcsetup.item.a_b_c_item.pricing.z3_price : null);
                if (zone_price_3) {
                    if ($(this).val() < zone_price_3*0.1) {
                        $(this).parent().append("<div class='alert alert-warning mt-1'> Our customers are less likely to hang this shelf talker if the Hot Price discount is less than 10% of the Zone 3 Retail Price which is <b>$ "+zone_price_3+"</b>.<br>Your sales results are likely to suffer if you continue with this Dollar Off amount. <br>We recommend increasing your  Dollar Off.</div>");
                        return;
                    }
                }
                $("#discount_dollar_reason").val('');
            }
        });

        abcsetup.promos.items.edit._shuttleboxUpdate();

        $(document).on('dblclick', ".shuttlebox-left option, .shuttlebox-right option", function(){
            abcsetup.promos.items.edit._shuttleboxUpdate();
        });

        $(document).on("click",".shuttlebox-add , .shuttlebox-remove",function() {
            abcsetup.promos.items.edit._shuttleboxUpdate();
        });

        this._bindRejectDropdown();

        if (abcsetup.userRole.class === 'vendor') {
            if ($("#temp_range").val() != "" && (abcsetup.item.item_status != 'vendor_in_process' && abcsetup.item.item_status != 'cm_rejected')) {
                $("#temp_range").attr('disabled',true).addClass('readonly');
            }
        }

        // Disable mousewheel incrementing on number input fields for
        // Chromium based browsers (Edge, Chrome)
        $('form').on('focus', 'input[type=number]', function (e) {
            $(this).on('wheel.disableScroll', function (e) {
            e.preventDefault()
            })
        });

        $('form').on('blur', 'input[type=number]', function (e) {
            $(this).off('wheel.disableScroll')
        });

        $(document).on('click', '.delete-attachment-autoappend', function(e) {
            abcsetup.promos.items.edit.attachment_delete_id = $(this).data('id');
        });

        /* ABCS-719 */
        if ($('#has_glamour_shot').val() == 1) {
            $('.attachment_file[data-type="Product Image"]').removeAttr('required').removeClass('required');
            $('.attachment_file[data-type="product_image"]').removeAttr('required').removeClass('required');
        }
    },

    _bindRejectDropdown: function () {
        $('.dropdown-menu.reject input.checkbox').prop('checked', false);

        $(document).on('click', '.dropdown-menu.reject', function (event) {
            event.stopPropagation();
        });

        $(document).on('click', '.dropdown-menu.reject input.checkbox', function () {
            if ($(this).prop('checked')) {
                $(this).closest('div.checkbox').find('textarea').prop('required',true).show();
            } else {
                $(this).closest('div.checkbox').find('textarea').hide().next('.errorMsg').remove();
            }
        });

        $(document).on('click', '.btn-reject', function(e) {
            const reject_fields = $(this).closest('div.dropdown-menu').find('input,textarea').each(function() {
                if($(this).prop('required') && $(this).val() == '') {
                    e.preventDefault();
                    $(this).addClass('is-invalid');
                    return false;
                }
            });
        });
    },

    _shuttleboxUpdate: function(){
        var desired_target_category = $("select[name*='desired_target_category']").val();
        var subcategory_shuttlebox_left = $("input[name='desired_target_sub_category']").closest('.shuttlebox').find('select.shuttlebox-left')
        var subcategory_shuttlebox_right = $("select[name='desired_target_sub_category[]'");
        var sub_categories = abcsetup.item.SubCategories
        var html = '' ;

        console.log('Length: ',subcategory_shuttlebox_left.find('option').length);
        if(subcategory_shuttlebox_left.find('option').length) {
           subcategory_shuttlebox_left.find('option').remove();
        }

        if(desired_target_category) {
           desired_target_category.forEach(function(category,index) {
            //   console.log('category: ' + category);
              for(key in sub_categories) {
                //  console.log('key-> '+ key + ' sub_categories ' + JSON.stringify(sub_categories[key],{},4));
                 var _category= sub_categories[key].category_id.replace(/"/g,"");
                //  console.log('_category: ',_category);
                 if( _category ==  category) {
                    html += '<option '+' value="'+sub_categories[key]['subcategory_id']+'">'+sub_categories[key]['category_name']+' - '+ sub_categories[key]['subcategory_name']+'</option>';
                 }
              }
           });
        }

        $(html).appendTo(subcategory_shuttlebox_left);
        subcategory_shuttlebox_right.find('option').each(function() {
           var subcategory_shuttlebox_right_option = $(this).val();
           var num_option_in_left = subcategory_shuttlebox_left.find('option[value='+subcategory_shuttlebox_right_option+']').val();
           if(num_option_in_left) {
              subcategory_shuttlebox_left.find('option[value='+subcategory_shuttlebox_right_option+']').remove();
           } else {
              $(this).remove();
           }
        });
        $(subcategory_shuttlebox_right).trigger('change');
    },

    attachmentRemoved: function(e) {
        let promo_id = abcsetup.promos.items.edit.promo_id;
        let item_id = abcsetup.promos.items.edit.item_id;
        let attachment_id = abcsetup.promos.items.edit.attachment_delete_id;

        abcsetup.blockUI(true);

        if (attachment_id == null || promo_id == null || item_id == null) {
            abcsetup.unblockUI();
            abcsetup.alerts.show('Could not remove item.', 'Could not remove this attachment at this time, please try again later.');
            return;
        }

        axios
            .post('/api/promoitem/remove_attachment', {
                'promo_id': promo_id,
                'item_id': item_id,
                'attachment_id': attachment_id
            })
            .then(response => {
                const data = response.data;
                const type = data.type;
                
                if (data && data.success) {
                    abcsetup.alerts.show('Attachment Removed', 'The attachment has been removed successfully.');

                    /* If the Promo is one of these types, reset the Product Image Button. */
                    if (type != null && ['bgp','eb','ecomm_sol','fg','prod_announce', 'cc', 'hhc', 'rr', 'rr2'].includes(type)) {
                        $('#product_image__promo_item' + item_id + '__')
                            .removeClass('btn-optional')
                            .addClass('btn-danger');

                        $('.attachment_file[data-type="Product Image"]').attr('required', 'required');
                        $('.attachment_file[data-type="product_image"]').attr('required', 'required');
                    }
                }

                abcsetup.unblockUI();
            })
            .catch(error => {
                abcsetup.unblockUI();
                console.error('Error removing attachment:', error.response.data.message);
                abcsetup.alerts.show('Could not remove attachment.', 'Could not remove this attachment at this time, please try again later.');
            });
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function() {
        // Note: all promo item form related JS is handled in the global /forms/_promo_item.js form namespace
        abcsetup.promos.items.form.init(true);
    },
}
